export const ADDRESSES_LOAD_SUCCESS = "ADDRESSES_LOAD_SUCCESS";



// WEBPACK FOOTER //
// ./src/store/AddressLookUp/actionTypes.js